import { Box, useTheme } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { memo } from "react";

const ModalWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: "20px",
  border: `5px solid ${theme.palette.common.secondory}`,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  padding: "35px 35px 34px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
  "& p": { fontSize: "16px", marginBottom: "8px", color: theme.palette.text.primary },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    "& .deleteLoader": {
      width: "24.5px !important",
      height: "24.5px !important",
      "& svg": {
        color: "#fff",
      },
    },
    "& button": {
      width: "calc(50% - 8px)",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      marginTop: "15px",
      "&:focus": { outline: "none" },
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
  },
}));

function KeywordSuggestionPopup({ open, onSubmit, onClose, suggestions, handleSuggestionClick }) {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <ModalWrapper>
          <Typography component="h4">Suggestion</Typography>
          <Typography component="p">Your input might be incorrect. You can either select a suggested keyword below or proceed with your input.</Typography>
          <Box sx={{ marginTop: "35px" }}>
            <Typography
              component="ul"
              sx={{
                display: "flex",
                pl: 0,
                alignItems: "center",
                gap: "15px",
                flexWrap: "wrap",
                "&  li": {
                  listStyle: "none",
                  backgroundColor: theme.palette.primary.light,
                  p: "5px 10px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.main,
                    color: "#fff",
                  },
                },
              }}
            >
              {suggestions.map(suggestion => (
                <Typography component="li" key={suggestion} onClick={() => handleSuggestionClick(suggestion)}>
                  {suggestion}
                </Typography>
              ))}
            </Typography>
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={onClose}>Cancel</Button>
            <Button
              onClick={() => {
                onSubmit();
                onClose();
              }}
            >
              Submit
            </Button>
          </Box>
        </ModalWrapper>
      </Fade>
    </Modal>
  );
}

export default memo(KeywordSuggestionPopup);
